export const audioTagsTrackingModule = {
  name: 'Audio Tags Tracking',
};
